import { createAction, props } from '@ngrx/store';

import { CardVerificationResponse } from '../../models/card-verification-response';

export const GetCard = createAction('[Verification] Get card');
export const GetCardSuccess = createAction(
  '[Verification] Get card success',
  props<CardVerificationResponse>(),
);
export const GetCardFail = createAction('[Verification] Get card fail');
